import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';

const brandNameHe = () => window.Config?.brand_Name_HE;
export const productsTypes = {
  CELLULAR: 'Cellular',
  TV: 'TV',
  INTERNET: 'Internet',
  MAPA: 'Mapa',
  BUNDLE: 'Bundle',
  MABAL: 'Mabal',
  UNKNOWN: 'Unknown',
};
export const productTypeDescription = {
  cellular: 'סלולר',
  internet: 'אינטרנט',
  tv: 'TV',
  mapa: 'טלפון',
};
export const productStatus = {
  UNKNOWN: 'Unknown',
  BUSINESS: 'Business',
  ACTIVE: 'Active',
  CANCELLED: 'Cancelled',
  SUSPENDED: 'Suspended', //מושהה
};
export const productStatusDescription = {
  BUSINESS: 'עסקי',
  CANCELLED: 'מבוטל',
  SUSPENDED: 'מושהה',
};
export const internetTypesDescription = {
  //????
  InternetInfra: 'אינטרנט ביתי',
  InternetInfraKosher: 'אינטרנט ביתי כשר',
  InternetIsp: 'גישה לאינטרנט',
  get InfraFiber() {
    return `${brandNameHe()} Fiber`;
  },
  InfraBezeq: 'אינטרנט ביתי',
  InfraHot: 'אינטרנט ביתי ',
  get InfraIbc() {
    return `${brandNameHe()} Fiber`;
  },
  get InfraBezeqFiber() {
    return `${brandNameHe()} Fiber`;
  },
};

export const toAllActionButtonText = {
  internet: 'לכל הפעולות באינטרנט',
  cellular: 'לכל הפעולות בסלולר',
  tv: 'לכל הפעולות ב-TV',
  mapa: 'לכל הפעולות בטלפון',
  mobileText: 'לביצוע פעולות',
  color: '#f4eefc',
};

export const popupTypes = {
  CELL_PACK_DATA: 'cell_pack_data',
  MABAL_SUBSCRIBERS: 'mabal_subscribers',
  ALL_ACTIONS: 'all_actions',
  DATA_USAGE_ALERT: 'data_usage_alert',
};

export const dataUsageWarningTooltipData = {
  title: 'חבילת הגלישה הסתיימה',
  text: 'לפרטים המלאים כנס ל- ״מידע על הגלישה שלי״',
};
export const getMyProductsAndServices = createAsyncThunk('productsAndServices/getMyProductsAndServices', async (res, thunkAPI) => {
  try {
    if (res.Mabal) {
      thunkAPI.dispatch(getRegisteredNumberListMabal());
    }
    return res;
  } catch (error) {
    return {error: true};
  }
});

export const getRegisteredNumberListMabal = createAsyncThunk('productsAndServices/getRegisteredNumberListMabal', async (thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getRegisteredNumberListMabal', []);
    return result.Body;
  } catch (error) {
    return {error: true};
  }
});

export const getCurrentPricePlan = createAsyncThunk('productsAndServices/getCurrentPricePlan', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getCurrentCellularPricePlan', [data.subscriberNo, data.ban]);
    return result.Body;
  } catch (error) {
    return {error: true};
  }
});

const popupInitialState = {
  popupData: null,
  popupOpen: false,
  popupType: '',
  title: '',
};

const initialState = {
  error: false,
  productsTypes: productsTypes,
  customerProducts: null,
  popup: popupInitialState,
  isLoading: false,
};

const productsAndServicesBlockSlice = createSlice({
  name: 'productsAndServices',
  initialState: initialState,
  reducers: {
    openMabalSubscribersPopup: (state, action) => {
      let mabalSubscribers = state.customerProducts.Mabal.find((item) => item.psId == action.payload).subscriberNumberList;
      state.popup.popupOpen = true;
      state.popup.popupType = popupTypes.MABAL_SUBSCRIBERS;
      state.popup.popupData = mabalSubscribers;
    },
    closePopup: (state, action) => {
      state.popup = popupInitialState;
    },
    getAllActionsPopup: (state, action) => {
      state.popup.popupOpen = true;
      state.popup.popupType = popupTypes.ALL_ACTIONS;
      state.popup.popupData = action.payload.actions;
      state.popup.popupTitle = `פעולות ב${productTypeDescription[action.payload.title.toLowerCase()]}`;
    },
    openDataUsageAlertPopup: (state, action) => {
      state.popup.popupOpen = true;
      state.popup.popupType = popupTypes.DATA_USAGE_ALERT;
    },
  },
  extraReducers: {
    [getMyProductsAndServices.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        state.customerProducts = action.payload;
      }
    },
    [getRegisteredNumberListMabal.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getRegisteredNumberListMabal.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (!action.payload.error) {
        state.customerProducts.Mabal = action.payload;
      }
    },
    [getCurrentPricePlan.pending]: (state) => {
      state.isLoading = true;
    },
    [getCurrentPricePlan.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (!action.payload.error) {
        state.popup.popupData = action.payload;
        state.popup.popupOpen = true;
        state.popup.popupType = popupTypes.CELL_PACK_DATA;
      }
    },
  },
});

export const {closePopup, openMabalSubscribersPopup, getAllActionsPopup, openDataUsageAlertPopup} = productsAndServicesBlockSlice.actions;
export default productsAndServicesBlockSlice.reducer;
